module.exports = __webpack_public_path__ + "static/media/yellowmargin-triggerfish.203215ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/yellowmargin-triggerfish.png
// module id = 341
// module chunks = 0